import * as types from '../types/paymentMethodTypes';

const initialState = {
  activeMethods: [],
  loading: false,
  error: null,
};

const paymentMethodReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_ACTIVE_PAYMENT_METHODS_REQUEST:
      return { ...state, loading: true, error: null };

    case types.FETCH_ACTIVE_PAYMENT_METHODS_SUCCESS:
      return {
        ...state,
        loading: false,
        activeMethods: action.payload || [],
        error: null,
      };

    case types.FETCH_ACTIVE_PAYMENT_METHODS_FAILURE:
      return {
        ...state,
        loading: false,
        activeMethods: [],
        error: action.payload,
      };

    case types.CLEAR_PAYMENT_METHOD_ERROR:
      return { ...state, error: null };

    default:
      return state;
  }
};

export default paymentMethodReducer;
